module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [(_vm.updateRequiredMessage) ? _c('div', {
    staticClass: "flash-message text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-info'
  }, [_vm._v(_vm._s(_vm.updateRequiredMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: _vm.detailsActive
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#details"
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', {
    class: _vm.settingsActive
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#settings"
    }
  }, [_vm._v("Settings")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content content"
  }, [_c('div', {
    staticClass: "tab-pane fade in",
    class: _vm.detailsActive,
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.firstName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'First Name:',
      "name": 'firstName',
      "messages": {
        required: 'This field is required'
      }
    },
    model: {
      value: (_vm.newProfile.firstName),
      callback: function($$v) {
        _vm.$set(_vm.newProfile, "firstName", $$v)
      },
      expression: "newProfile.firstName"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.lastName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'Last Name:',
      "name": 'lastName',
      "messages": {
        required: 'This field is required'
      }
    },
    model: {
      value: (_vm.newProfile.lastName),
      callback: function($$v) {
        _vm.$set(_vm.newProfile, "lastName", $$v)
      },
      expression: "newProfile.lastName"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.email),
    attrs: {
      "auto-label": "",
      "debounce": 250,
      "custom": {
        email: _vm.emailValidator,
        notUnique: _vm.emailUniqueValidator
      }
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'email',
      "label": 'Email:',
      "name": 'email',
      "messages": {
        email: 'Please input a valid email',
        required: 'This field is required',
        notUnique: 'That email is already in use.'
      }
    },
    model: {
      value: (_vm.newProfile.email),
      callback: function($$v) {
        _vm.$set(_vm.newProfile, "email", $$v)
      },
      expression: "newProfile.email"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.title),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'Title:',
      "placeholder": 'Ex: Central Marketing Developer',
      "name": 'title',
      "messages": {}
    },
    model: {
      value: (_vm.newProfile.title),
      callback: function($$v) {
        _vm.$set(_vm.newProfile, "title", $$v)
      },
      expression: "newProfile.title"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.location),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'Location:',
      "placeholder": 'City, State, Country',
      "name": 'location',
      "messages": {}
    },
    model: {
      value: (_vm.newProfile.location),
      callback: function($$v) {
        _vm.$set(_vm.newProfile, "location", $$v)
      },
      expression: "newProfile.location"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.education),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'Education:',
      "placeholder": 'Ex: B.S. in Computer Science from the University of Tennessee at Knoxville',
      "name": 'education',
      "messages": {}
    },
    model: {
      value: (_vm.newProfile.education),
      callback: function($$v) {
        _vm.$set(_vm.newProfile, "education", $$v)
      },
      expression: "newProfile.education"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v("Bio:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProfile.bio),
      expression: "newProfile.bio"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "placeholder": "Ex: I'm an amazingly interesting person!"
    },
    domProps: {
      "value": (_vm.newProfile.bio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newProfile, "bio", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "py-2 text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.formstate.$dirty || _vm.formstate.$invalid
    },
    on: {
      "click": _vm.updateProfile
    }
  }, [_vm._v("Update Profile")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.deleteUserModal
    }
  }, [_vm._v("Delete Account")])]), _vm._v(" "), _c('div', {
    staticClass: "py-2 text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    class: _vm.settingsActive,
    attrs: {
      "id": "settings"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4"
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.passwordFormstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updatePassword($event)
      }
    }
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.passwordFormstate.newPassword),
    attrs: {
      "auto-label": "",
      "debounce": 250,
      "custom": {
        notStrong: _vm.passwordScoreValidator
      }
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "passwordFormstate": _vm.passwordFormstate,
      "type": 'password',
      "label": 'New Password:',
      "name": 'newPassword',
      "placeholder": 'Please enter your new password.',
      "messages": {
        required: 'This field is required',
        notStrong: 'Password not strong enough'
      }
    },
    on: {
      "input": _vm.validateConfirm
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.passwordFormstate.confirmPassword),
    attrs: {
      "auto-label": "",
      "debounce": 250,
      "custom": {
        notMatch: _vm.passwordConfirmValidator
      }
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "passwordFormstate": _vm.passwordFormstate,
      "type": 'password',
      "label": 'Confirm Password:',
      "name": 'confirmPassword',
      "placeholder": 'Please confirm your password.',
      "messages": {
        required: 'This field is required',
        notMatch: 'Passwords do not match'
      }
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-centered"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.passwordFormstate.$dirty || _vm.passwordFormstate.$invalid || _vm.passwordScoreUpdating
    }
  }, [_vm._v("Update Password")])])], 1)], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d91ffe5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/profile/Profile.vue
// module id = 2017
// module chunks = 1